// extracted by mini-css-extract-plugin
export default {"root":"ProfileUser_root__4hVPs","wrapInfo":"ProfileUser_wrapInfo__KP+9N","dot":"ProfileUser_dot__SbKy1"};